import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { FormActionProps } from "../../@types/";

const useStyles = makeStyles(() => ({
  formWrapper: {
    width: "70%",
    maxWidth: "500px",
    margin: "10px auto",
    borderRadius: "10px",
    padding: "20px 10px"
  },
  buttonContainer: {
    width: "50%",
    margin: "20px auto 0px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridTemplateRows: "1fr",
    gap: "0px 0px",
    gridTemplateAreas: ". . ."
  }
}));

const Form = (props: FormActionProps) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.formWrapper} bgcolor="primary.main">
        <Typography align="center" variant="h5" color="textPrimary">
          {props.title}
        </Typography>
        <Typography align="center" variant="subtitle1" color="textPrimary">
          {props.description}
        </Typography>
        <div className={classes.buttonContainer}>
          {props.cancelButton}
          <div />
          {props.submitButton}
        </div>
      </Box>
    </>
  );
};

export default Form;
